import React from 'react';
import CollapseMenu from './Components/CollapseMenu/index.js';
import cx from 'classnames';

var prefix = 'mb-qianfan-portal-footer';
var MobileFooter = function MobileFooter(props) {
  var _a;
  var _b, _c, _d, _e, _f, _g, _h;
  var columns = props.columns,
    mobileColumns = props.mobileColumns,
    qrCodes = props.qrCodes,
    copyRight = props.copyRight;
  var copyRightCmp = copyRight === null || copyRight === void 0 ? void 0 : copyRight.map(function (item, index) {
    var text = item.text,
      link = item.link,
      _a = item.target,
      target = _a === void 0 ? '_blank' : _a;
    return text && (/*#__PURE__*/React.createElement("span", {
      key: index
    }, link ? (/*#__PURE__*/React.createElement("a", {
      href: link,
      target: target,
      rel: "noopener noreferrer"
    }, text)) : text));
  });
  var _mobileColumns = mobileColumns || columns;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-wrapper")
  }, /*#__PURE__*/React.createElement("div", {
    className: prefix
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-top")
  }, _mobileColumns === null || _mobileColumns === void 0 ? void 0 : _mobileColumns.map(function (column, index) {
    return /*#__PURE__*/React.createElement(CollapseMenu, {
      key: index,
      title: column[0].text
    }, column === null || column === void 0 ? void 0 : column.map(function (item, index) {
      var _a, _b, _c, _d, _e, _f;
      var text = item.text,
        link = item.link,
        _g = item.target,
        target = _g === void 0 ? '_blank' : _g;
      if (index === 0) return;
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "".concat(prefix, "-line")
      }, link ? (/*#__PURE__*/React.createElement("a", {
        href: link,
        target: target,
        rel: "noopener noreferrer",
        "data-track-name": (_b = (_a = item.trackInfo) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "文字链",
        "data-track-value": (_d = (_c = item.trackInfo) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : text,
        "data-track-category": (_f = (_e = item.trackInfo) === null || _e === void 0 ? void 0 : _e.category) !== null && _f !== void 0 ? _f : "底部导航"
      }, text)) : text);
    }));
  })), ((_b = qrCodes === null || qrCodes === void 0 ? void 0 : qrCodes.list) === null || _b === void 0 ? void 0 : _b.length) && (/*#__PURE__*/React.createElement("div", {
    className: cx("".concat(prefix, "-content"), (_a = {}, _a["".concat(prefix, "--column")] = (qrCodes === null || qrCodes === void 0 ? void 0 : qrCodes.list.length) > 1, _a))
  }, ((_c = qrCodes === null || qrCodes === void 0 ? void 0 : qrCodes.list) === null || _c === void 0 ? void 0 : _c.length) > 1 ? (/*#__PURE__*/React.createElement(React.Fragment, null, (qrCodes === null || qrCodes === void 0 ? void 0 : qrCodes.title) && (/*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-logo-title")
  }, qrCodes === null || qrCodes === void 0 ? void 0 : qrCodes.title)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-logo-list")
  }, (_d = qrCodes === null || qrCodes === void 0 ? void 0 : qrCodes.list) === null || _d === void 0 ? void 0 : _d.map(function (item, index) {
    var url = item.url,
      text = item.text;
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "".concat(prefix, "-logo")
    }, /*#__PURE__*/React.createElement("img", {
      src: url,
      alt: text
    }), text && (/*#__PURE__*/React.createElement("span", {
      className: "".concat(prefix, "-logo-desc")
    }, text)));
  })))) : (/*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-logo")
  }, /*#__PURE__*/React.createElement("img", {
    src: (_e = qrCodes === null || qrCodes === void 0 ? void 0 : qrCodes.list) === null || _e === void 0 ? void 0 : _e[0].url,
    alt: (_f = qrCodes === null || qrCodes === void 0 ? void 0 : qrCodes.list) === null || _f === void 0 ? void 0 : _f[0].text
  }), ((_g = qrCodes === null || qrCodes === void 0 ? void 0 : qrCodes.list) === null || _g === void 0 ? void 0 : _g[0].text) && (/*#__PURE__*/React.createElement("span", null, (_h = qrCodes === null || qrCodes === void 0 ? void 0 : qrCodes.list) === null || _h === void 0 ? void 0 : _h[0].text)))))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-bottom")
  }, copyRightCmp)));
};

export { MobileFooter as default };
